import "antd/dist/antd.css";

import { BrowserRouter as Router } from "react-router-dom";

import AuthContextProvider from "./context/AuthContext";
import ConfigRoutes from "./routes";

function App() {
  return (
    <Router>
      <AuthContextProvider>
        <ConfigRoutes />
      </AuthContextProvider>
    </Router>
  );
}

export default App;
